var priceRegex = /^((0|[1-9]+[\d]*)(\.[\d]{0,2})?)?$/;
export var normalizePrice = function (value, previousValue, _a) {
    var _b = _a === void 0 ? {} : _a, min = _b.min, max = _b.max;
    value = value.match(priceRegex) ? value : previousValue;
    if (max) {
        value = Number(value) > max ? max.toString() : value;
    }
    if (min) {
        value = Number(value) < min ? min.toString() : value;
    }
    return value;
};
//# sourceMappingURL=validator.js.map